export const educationData = [
    {
        id: 1,
        institution: 'The University of Texas at Arlington',
        course: 'MS in Computer Science',
        startYear: '2021',
        endYear: '2023'
    },
    {
        id: 2,
        institution: 'Jawaharlal Nehru Technological University',
        course: 'Bachelor of Technology in Computer Science',
        startYear: '2013',
        endYear: '2017'
    },
    {
        id: 3,
        institution: 'Narayana Junior college',
        course: 'Mathematics, Physics and Chemistry',
        startYear: '2011',
        endYear: '2013'
    },
    {
        id: 4,
        institution: 'Vikas Concept School',
        course: 'I - X',
        startYear: '2001',
        endYear: '2011'
    },
]